import { StrictMode } from 'react';
import * as ReactDOMClient from 'react-dom/client';

import { disableReactDevTools } from '@fvilers/disable-react-devtools';

import App from './App';

import { isDevMode } from '~/core/utils';

if (!isDevMode()) {
  disableReactDevTools();
}

// this is the new root API
const container = document.getElementById('root');

if (container) {
  const root = ReactDOMClient.createRoot(container);

  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
